import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import { settingsAdd, settingsDelete, settingsLoadAll } from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(settingsAdd.type, send, socket);
  yield takeEvery(settingsLoadAll.type, send, socket);
  yield takeEvery(settingsDelete.type, send, socket);
}
